export interface MonthlyNews {
  year: number;
  month: number;
  headline: string;
  summary: string;
  policy: string[];
  issues: string[];
  seoulMarket: string;
  interestRate: string;
  reconstruction: string;
  outlook: string;
}

const newsData: MonthlyNews[] = [
  {
    year: 2025,
    month: 1,
    headline: "윤석열 대통령 탄핵 정국 속 부동산 시장 관망세, 기준금리 3.00% 동결",
    summary:
      "대통령 탄핵 정국의 불확실성 속에서 부동산 시장은 관망세를 보였으나, 금리 인하 기대감과 공급 부족 우려가 맞물리며 서울 아파트 가격은 보합 수준을 유지했다.",
    policy: [
      "윤석열 대통령 탄핵소추안이 2024년 12월 14일 국회에서 가결된 이후, 한덕수 국무총리 권한대행 체제하에서 부동산 정책은 기존 기조를 유지했다. 정치적 불확실성으로 인해 대규모 신규 정책 발표는 사실상 중단된 상태였다.",
      "국토교통부는 2025년 업무보고에서 수도권 중심 주택공급 확대 기조를 재확인하며, 3기 신도시 사전청약 및 도심 정비사업 촉진을 핵심 과제로 제시했다.",
      "2025년 1월부터 청약저축 소득공제 혜택이 무주택 세대주뿐 아니라 배우자까지 확대되었으며, 납입액 40%(연 300만원 한도)까지 공제 혜택이 주어졌다.",
      "재건축 조합설립에 필요한 주민 동의율 요건이 75%에서 70%로 낮아지는 개정안이 4월 시행을 앞두고 공포되었다. 상가 소유자 동의 요건도 1/2에서 1/3으로 완화되었다.",
      "비수도권 준공 후 미분양 주택 취득 시 양도세·종부세·취득세 부담 완화 조치가 시행되어, 지방 미분양 해소를 위한 세제 인센티브가 본격 가동되었다.",
    ],
    issues: [
      "탄핵 정국에 따른 정치적 불확실성이 부동산 시장 전반에 관망세를 유발했다. 매수자와 매도자 모두 상황을 지켜보는 분위기가 지배적이었으며, 서울 아파트 거래량은 전월 대비 감소했다.",
      "강남 3구(강남·서초·송파) 재건축 단지들의 호가는 소폭 상승세를 이어갔다. 정치적 불확실성에도 불구하고 공급 부족에 대한 우려가 가격 하방을 지지했다.",
      "전세사기 후속 대책의 일환으로 전세보증금 반환보증 의무화 논의가 본격화되었다. 2024년 대규모 전세사기 사건들의 후폭풍이 여전히 시장에 영향을 미치고 있었다.",
      "2024년 3월 개통한 GTX-A 노선(수서~동탄) 이용객이 꾸준히 증가하면서 노선 연선 아파트에 대한 관심이 지속되었다. 동탄, 성남 등 연선 지역의 매수 문의가 증가했다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 1월까지 보합~약보합 흐름을 유지했다. 한국부동산원 기준 주간 변동률은 0.00~0.02% 수준에 그치며 뚜렷한 방향성을 보이지 않았다. 탄핵 정국의 불확실성이 매수심리를 위축시킨 영향이 컸다. 거래량도 전월 대비 감소하며 월 3,500건 수준에 머물렀다. 다만 강남·서초 등 핵심 입지의 신축 아파트는 호가가 유지되거나 소폭 상승하는 양극화 양상이 나타났다.",
    interestRate:
      "한국은행은 1월 금통위에서 기준금리를 3.00%로 동결했다. 2024년 10월(3.25%)과 11월(3.00%) 연속 인하 이후 경기 둔화 우려는 여전했으나, 환율 불안(원/달러 1,450원대)과 가계부채 관리 필요성을 이유로 추가 인하를 유보했다. 미국 연준은 1월 FOMC에서 기준금리를 4.25~4.50%로 동결했다. 트럼프 2기 행정부 출범(1/20)에 따른 정책 불확실성이 반영되었다. 시중 주담대 금리는 변동금리 기준 4.0~4.8%, 고정금리 4.2~5.0% 수준이었다.",
    reconstruction:
      "재건축 조합설립 동의율 완화(75%→70%) 시행을 앞두고 서울 주요 재건축 단지들의 추진위원회 활동이 활발해졌다. 은마아파트는 신속통합기획(신통기획) 자문을 통해 최고 49층, 5,893가구 규모의 재건축안을 확정한 상태로, 2025년 중 조합설립인가를 목표로 동의서 징구에 박차를 가하고 있었다. 잠실 올림픽선수기자촌(5,540가구)도 신통기획 자문 절차에 돌입했다.",
    outlook:
      "헌법재판소의 탄핵 심판 결과가 부동산 시장의 최대 변수로 작용할 전망이었다. 조기 대선 시나리오에서는 새 정부의 부동산 정책 방향에 따라 시장 흐름이 크게 달라질 수 있다는 분석이 지배적이었다. 단기적으로는 금리 인하 기대감이 매수심리를 자극할 수 있으나, 정치적 불확실성이 해소되기 전까지 거래량 회복은 제한적일 것으로 전망되었다.",
  },
  {
    year: 2025,
    month: 2,
    headline: "한국은행 기준금리 2.75%로 인하, 서울 아파트 가격 상승 전환",
    summary:
      "한국은행이 기준금리를 0.25%p 인하한 2.75%로 결정하면서 시장에 유동성 기대감이 확산되었고, 서울 아파트 매매가격이 보합세에서 벗어나 상승 전환했다.",
    policy: [
      "한국은행은 2월 금통위에서 기준금리를 3.00%에서 2.75%로 0.25%p 인하했다. 1분기 GDP 성장률이 시장 전망을 하회하고, 물가 상승률이 2%대로 안정된 점이 인하 근거로 작용했다.",
      "2월 7일 '도심복합개발 지원에 관한 법률'이 시행되었다. 역세권·준공업지역 등 도심 내 유휴 부지를 복합개발할 수 있는 법적 기반이 마련되었으며, 성장거점형과 주거중심형으로 구분하여 지역 특성에 맞는 개발을 유도했다.",
      "국토교통부는 청약제도 개편안을 발표하며, 무주택 실수요자를 위한 가점제 비중 확대와 신혼부부·다자녀 가구 특별공급 확대 방안을 제시했다.",
      "금융위원회는 스트레스 DSR(총부채원리금상환비율) 2단계 확대 적용을 추진하며, 가계부채 관리 강화 의지를 재확인했다.",
      "서울시는 역세권 고밀 개발 가이드라인을 확정 발표하며, 주요 지하철역 주변 용적률 상향을 통한 주택공급 확대 방안을 구체화했다.",
    ],
    issues: [
      "설 연휴(1/28~1/30) 전후로 매매·전세 거래가 일시적으로 급감했으나, 연휴 이후 기준금리 인하 효과가 맞물리며 매수 문의가 빠르게 증가했다. 서울 아파트 매매가격은 2월 첫째 주를 기점으로 상승 전환하며 이후 46주 연속 상승의 시작점이 되었다.",
      "마용성(마포·용산·성동) 지역의 전세 매물이 크게 감소하면서 전세가율이 높아졌다. 일부 지역에서는 갭투자 재등장 우려가 제기되었다.",
      "인천 검단·청라 등 수도권 외곽 지역의 미분양 물량이 증가세를 보였다. 수도권과 비수도권 간 양극화가 심화되는 조짐이 나타났다.",
      "헌법재판소의 탄핵 심판이 진행 중인 가운데, 조기 대선 가능성이 부동산 시장의 주요 불확실성 요인으로 작용했다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 2월 첫째 주(2월 3일 기준)를 기점으로 상승 전환했다. 한국부동산원 주간 변동률이 0.02~0.05% 수준으로 플러스로 돌아서며, 이후 연말까지 이어지는 장기 상승세의 출발점이 되었다. 강남구·서초구·송파구를 중심으로 상승세가 시작되었고, 마포·용산·성동 등 한강벨트로 확산되는 양상이었다. 거래량은 설 연휴 영향으로 전월 대비 35% 감소한 약 2,800건에 그쳤으나, 2월 하순부터 회복세를 보였다.",
    interestRate:
      "한국은행은 2월 금통위에서 기준금리를 2.75%로 0.25%p 인하했다. 2024년 10월부터 세 차례 연속 인하(3.50%→3.25%→3.00%→2.75%)로 누적 0.75%p가 내려갔다. 금통위원 일부에서는 추가 인하 필요성을 주장하며, 시장에서는 상반기 중 추가 인하 기대감이 확산되었다. 미국에서는 1월 고용지표가 호조(비농업 고용 35만 명 증가)를 보이며 연준의 금리 인하가 지연될 수 있다는 우려가 제기되었다. 원/달러 환율은 1,430~1,460원대에서 등락했다.",
    reconstruction:
      "도심복합개발법 시행(2/7)으로 역세권·준공업지역의 복합개발이 본격 추진될 수 있는 법적 기반이 마련되었다. 은마아파트 재건축 추진위는 조합설립 동의서 징구율을 높이기 위한 주민 설명회를 연이어 개최했다. 여의도 시범아파트, 한양아파트 등 영등포권 재건축 단지들도 신통기획 자문 신청을 준비하며 사업 속도를 높이려는 움직임을 보였다.",
    outlook:
      "금리 인하 사이클이 본격화됨에 따라 주택 매수심리가 살아날 것이라는 전망이 우세했다. 다만 헌재 탄핵 심판 결과에 따른 정치 변동성이 최대 변수였다. 봄 이사철 수요가 3~4월에 집중될 것으로 예상되며, 서울 핵심지를 중심으로 거래량이 회복될 것이라는 분석이 나왔다.",
  },
  {
    year: 2025,
    month: 3,
    headline: "봄 이사철 거래량 반등, 탄핵 심판 결론 초읽기",
    summary:
      "봄 이사철 수요가 본격화되면서 서울 아파트 거래량이 전월 대비 40% 이상 반등했다. 헌법재판소 탄핵 심판이 막바지에 접어들며 4월 초 선고가 예고되어 시장의 긴장감이 고조되었다.",
    policy: [
      "헌법재판소의 탄핵 심판이 막바지에 접어들며 4월 초 선고가 예고되었다. 부동산 시장은 탄핵 인용 시 조기 대선과 새 정부의 정책 방향에 촉각을 곤두세웠다.",
      "3월에는 금통위가 개최되지 않았다(연 8회 운영). 2월 인하 효과를 관찰하며 4월 금통위에서 추가 인하 여부를 결정할 것이라는 전망이 우세했다.",
      "국토교통부는 공공재개발 2차 후보지 10곳을 추가 발표했다. 서울 도심 내 노후 주거지를 공공 주도로 정비하여 주택공급을 늘리겠다는 계획이었다.",
      "서울시는 토지거래허가구역 일부 해제를 검토한다고 발표했다. 강남 3구와 용산 등에 적용되던 토허구역 규제를 조정하여 거래 정상화를 유도하려는 움직임이었다.",
      "4월부터 시행되는 재건축 조합설립 동의율 완화(75%→70%)를 앞두고 서울 주요 재건축 단지들의 동의서 징구가 가속화되었다.",
    ],
    issues: [
      "봄 이사철 수요가 본격화되면서 서울 아파트 거래량이 전월 대비 40% 이상 반등했다. 특히 송파구·강동구의 신축 아파트를 중심으로 거래가 활발했다.",
      "GTX-A 노선 수서~동탄 구간 시범운행이 본격화되면서, 노선 연선 아파트들의 가격 재평가가 이루어졌다. 동탄신도시와 성남 지역의 매수 문의가 크게 증가했다.",
      "반포·잠실 주요 재건축 단지의 추가분담금이 1~3억원 수준으로 확정되면서 논란이 일었다. 분담금 부담이 큰 조합원들의 반발과 사업 지연 우려가 제기되었다.",
      "전세가격도 상승세로 전환하며 전세 매물 품귀 현상이 일부 지역에서 나타났다. 전세가율 상승은 갭투자 유인을 높여 매매시장에도 영향을 미칠 수 있다는 분석이 나왔다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 전월 대비 0.15~0.20% 상승하며 3개월 연속 오름세를 이어갔다. 봄 이사철 효과와 금리 인하 기대감이 맞물리며 매수세가 유입되었다. 송파구·강동구 신축 중심의 거래가 활발했고, 강남·서초는 재건축 기대감으로 호가가 추가 상승했다. 전세가격도 0.10% 내외 상승하며 전세 매물 품귀 현상이 일부 지역에서 나타났다. 거래량은 월 4,500건 수준으로 전월 대비 크게 반등했다.",
    interestRate:
      "3월에는 금통위가 개최되지 않았다(연 8회 운영). 2월 인하(3.00%→2.75%) 이후 시장 반응을 관찰하는 기간이었으며, 4월 17일 금통위에서의 추가 인하 여부가 관심사였다. 미국 연준은 3월 FOMC에서 기준금리를 4.25~4.50%로 동결했다. 트럼프 행정부의 관세 정책 불확실성이 인플레이션 전망에 영향을 미치며 연준의 신중한 접근이 이어졌다. 시중 주담대 금리는 변동금리 기준 3.8~4.5% 수준으로 완만한 하락세를 보였다.",
    reconstruction:
      "4월 시행을 앞둔 재건축 조합설립 동의율 완화(75%→70%)가 시장의 관심을 끌었다. 은마아파트는 조합설립 동의율 확보에 속도를 내며, 연내 조합설립인가를 목표로 추진 중이었다. 잠실 올림픽선수기자촌(5,540가구)은 3월 신속통합기획 자문을 시작했다. 목동 신시가지 14개 단지 중 마지막으로 안전진단을 통과한 11단지의 재건축 추진도 본격화되었다.",
    outlook:
      "4월 탄핵 선고를 앞두고 조기 대선 가능성에 따른 정책 변화가 시장의 최대 관심사였다. 각 정당 대선 후보군의 부동산 공약에 대한 관심이 높아졌다. 봄 이사철이 4월까지 이어지며 거래량 회복이 지속될 것으로 전망되었다.",
  },
  {
    year: 2025,
    month: 4,
    headline: "헌재 탄핵 인용·조기 대선 확정, 재건축 기대감 속 강남 가격 급등",
    summary:
      "헌법재판소가 4월 4일 윤석열 대통령 탄핵을 인용하면서 60일 내 조기 대선이 확정되었다. 한국은행은 4월 금통위에서 2.75%를 동결했고, 강남권 재건축 단지를 중심으로 가격 상승이 가속화되었다.",
    policy: [
      "헌법재판소는 4월 4일 윤석열 대통령에 대한 탄핵소추를 인용했다(재판관 8:0 전원일치). 이에 따라 60일 이내 대통령 선거가 실시되게 되었으며, 부동산 시장은 새 정부의 정책 방향에 촉각을 곤두세웠다.",
      "한국은행은 4월 17일 금통위에서 기준금리를 2.75%로 동결했다. 2월 인하 효과를 관찰하며, 탄핵 인용에 따른 정치적 불확실성 속에서 신중한 접근을 유지했다.",
      "조기 대선 캠페인이 본격화되면서 각 후보의 부동산 공약이 쏟아졌다. 이재명 후보는 '250만호 공급'과 함께 투기수요 억제를 위한 규제 강화를 공약했고, 기타 후보들도 다양한 주택정책을 제시했다.",
      "5월 1일 시행 예정인 재건축 조합설립 동의율 완화(75%→70%)를 앞두고 시장 기대감이 높아졌다. 금융위원회는 가계부채 관리 강화를 위해 DSR 규제 적용 범위 확대를 예고했다.",
    ],
    issues: [
      "탄핵 인용으로 정치적 불확실성이 해소되면서 강남 3구를 중심으로 재건축 아파트 호가가 급등했다. 5월 동의율 완화 시행을 앞두고 은마아파트, 대치 쌍용, 잠실 주공 등 대형 단지의 호가가 수천만원에서 수억원 단위로 올랐다.",
      "봄 이사철 후반부까지 매수세가 이어지며 서울 아파트 거래량이 5,000건을 넘어섰다. 특히 중대형 평형의 거래 비중이 증가했다.",
      "건설업계에서는 원자재 가격 상승과 인건비 인상으로 분양가 인상이 불가피하다는 목소리가 커졌다. 신축 분양가 상승이 기존 아파트 가격에도 상승 압력으로 작용했다.",
      "전세시장에서도 매물 품귀 현상이 확산되었다. 서울 주요 지역의 전세가율이 60%에 근접하며, 전세가 상승이 매매가를 밀어올리는 구조가 강화되었다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격 상승폭이 확대되기 시작했다. 한국부동산원 주간 상승률이 0.08~0.12% 수준으로 올라서며 월간으로는 0.30% 이상 상승한 것으로 추정된다. 강남구(0.50% 이상), 서초구(0.45% 이상) 등 강남권이 상승을 주도했고, 송파·강동도 뒤를 이었다. 반면 노원·도봉·강북 등 외곽 지역은 0.01~0.05% 소폭 상승에 그치며 양극화가 뚜렷해졌다. 거래량은 월 5,200건 수준으로 봄 이사철 효과가 이어졌다.",
    interestRate:
      "한국은행은 4월 17일 금통위에서 기준금리를 2.75%로 동결했다. 2월 인하 효과를 관찰하며 신중한 접근을 유지했다. 부동산 시장 과열 조짐이 인하에 부담이 될 수 있다는 견해도 있었으나, 경기 둔화 우려가 더 크다는 전망이 우세했다. 미국 트럼프 행정부는 중국산 제품에 추가 관세(25%)를 부과하며 미중 무역갈등이 재점화되었다. 원/달러 환율이 1,400원대 초중반에서 등락했다.",
    reconstruction:
      "5월 1일 시행 예정인 재건축 동의율 완화(75%→70%)를 앞두고 서울 주요 재건축 단지들의 사업 추진이 활발해졌다. 은마아파트는 49층 5,893가구 규모의 재건축안을 확정하고 조합설립 동의서 징구에 박차를 가했다. 잠실동 아시아선수촌(1,356가구)은 정비계획 입안 제안을 위한 주민 동의서를 받기 시작했다. 서울시는 신통기획 시즌2를 통해 강남·여의도·목동 등 주요 지역의 정비사업 속도를 높이겠다고 밝혔다.",
    outlook:
      "6월 3일 조기 대선을 앞두고 부동산 시장의 정책 불확실성이 최고조에 달했다. 새 정부 출범 이후 규제 강화 가능성이 매수세를 자극하는 '패닉 바잉' 우려도 제기되었다. 5월 금통위에서의 추가 금리 인하 여부와 재건축 동의율 완화(5/1 시행)가 관전 포인트였다.",
  },
  {
    year: 2025,
    month: 5,
    headline: "재건축 동의율 완화 시행, 기준금리 2.50%로 인하 — 대선 앞두고 시장 과열",
    summary:
      "5월 1일 재건축 조합설립 동의율 완화가 시행되었고, 한국은행도 기준금리를 2.50%로 인하하면서 6월 대선을 앞두고 부동산 시장의 과열 조짐이 나타났다.",
    policy: [
      "5월 1일부터 재건축 조합설립에 필요한 주민 동의율이 75%에서 70%로 완화되었다. 상가 소유자 동의 요건도 1/2에서 1/3으로 낮아졌다. 그동안 동의율 확보에 어려움을 겪던 대형 단지들의 사업 추진이 탄력을 받았다.",
      "한국은행은 5월 29일 금통위에서 기준금리를 2.75%에서 2.50%로 0.25%p 인하했다. 1분기 GDP 성장률이 전년 동기 대비 1.3%로 시장 전망을 하회하며 실물경제 회복이 미진한 점이 인하 배경이었다.",
      "6월 3일 조기 대선을 앞두고 각 후보의 부동산 정책 공약이 시장에 영향을 미쳤다. 이재명 후보의 '250만호 공급'과 규제 강화 공약이 주목받았다.",
      "금융위원회는 가계부채 관리를 위해 스트레스 DSR 2단계 확대 적용을 본격 시행했다. 수도권 주담대에 대한 DSR 산정 시 추가 가산금리가 적용되었다.",
      "전세 안심보증 한도 확대(6억→9억원)가 발표되어 전세보증 사각지대 해소를 위한 조치가 시행되었다.",
    ],
    issues: [
      "재건축 동의율 완화 시행과 금리 인하가 맞물리며 시장 과열 조짐이 나타났다. 6월 대선 이후 규제 강화 가능성이 제기되면서 '규제 전 매수' 심리가 작용했다.",
      "서울 전세 매물이 2년 내 최저 수준으로 감소했다. 수도권 입주물량이 전년 대비 25% 감소하면서 전세난 장기화 우려가 확산되었다.",
      "사전청약 당첨자들의 이주 수요가 인근 지역 전세가 상승을 압박했다. 특히 3기 신도시 예정지 주변의 전세가 변동이 컸다.",
      "서울 주요 구역의 신축 분양가가 3.3㎡당 평균 4,000만원을 넘어서며, 분양시장의 고가화 추세가 뚜렷해졌다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 주간 0.10~0.15% 상승을 이어가며 월간 0.40% 이상 오른 것으로 추정된다. 금리 인하와 공급 부족 우려가 가격 상승을 견인했다. 마포·영등포 등 중가 지역의 거래가 활발해지며 상승 지역이 확대되었다. 전세가격도 0.15~0.20% 상승하며 매매보다 높은 상승률을 기록했다. 전세가율 60%를 돌파하는 단지가 속출하며, 전세가 상승이 매매가를 밀어올리는 구조가 강화되었다.",
    interestRate:
      "한국은행은 5월 29일 기준금리를 2.50%로 0.25%p 인하했다. 2024년 10월 이후 네 번째 인하로, 누적 인하폭은 1.00%p(3.50%→2.50%)에 달했다. 경기 하방 압력이 인하의 주된 배경이었다. 미국 연준은 5월 FOMC에서 기준금리를 4.25~4.50%로 동결했다. 관세 정책에 따른 인플레이션 불확실성이 인하를 미루게 했다. 시중 주담대 금리는 변동금리 기준 3.5~4.2% 수준으로 하락세가 이어졌다.",
    reconstruction:
      "재건축 동의율 완화(75%→70%) 시행 직후, 은마아파트 재건축은 조합설립 동의율 확보에 탄력을 받으며 조합설립인가 신청을 준비 중이었다. 서울시는 은마를 포함한 강남권 재건축을 시작으로 '신통기획 시즌2'를 본격화하겠다고 밝혔다. 여의도 시범아파트와 한양아파트 등 영등포권 재건축도 신통기획 자문 절차가 진행되었다. 새 정부의 재건축 정책 방향에 대한 기대와 우려가 공존했다.",
    outlook:
      "6월 3일 대선 결과에 따른 새 정부의 부동산 정책 방향이 시장의 최대 관심사였다. 금리 인하 사이클이 끝물에 접어들었다는 분석과 함께, 추가 인하 여부는 부동산 시장 과열 정도에 달려 있다는 견해가 우세했다.",
  },
  {
    year: 2025,
    month: 6,
    headline: "이재명 대통령 당선·취임, 첫 부동산 대책(6·27 대책) 발표",
    summary:
      "6월 3일 조기 대선에서 이재명 후보가 당선되어 새 정부가 출범했고, 첫 부동산 대책인 6·27 대책을 발표하며 수요 억제에 나섰다.",
    policy: [
      "이재명 정부가 6월 27일 첫 부동산 대책(6·27 대책)을 발표했다. 수도권 과열 지역에 대한 규제 강화와 주택공급 확대를 골자로 한 '투트랙' 전략이었다.",
      "금융위원회는 가계부채 관리 강화의 일환으로 스트레스 DSR 2단계 확대 적용 범위를 넓혔다. 수도권·규제지역 내 모든 주담대에 스트레스 금리가 가산되었다.",
      "국토교통부는 3기 신도시(남양주왕숙·하남교산) 사전청약 일정을 공개하며 하반기 공급 확대 의지를 재확인했다.",
      "미국 연준은 6월 FOMC에서 기준금리를 4.25~4.50%로 동결했다. 인플레이션 둔화가 확인되었으나 트럼프 행정부의 관세 정책 불확실성이 인하를 제약했다.",
      "6월 금통위는 개최되지 않았다(연 8회 운영). 5월 인하(2.50%) 효과를 관찰하는 기간이었으며, 7월 금통위에서의 결정이 주목되었다.",
    ],
    issues: [
      "상반기 서울 아파트 매매가격은 한국부동산원 기준 누적 약 3~4% 상승하며 본격적인 상승 구간에 진입했다. 강남권을 중심으로 신고가 거래가 이어졌다.",
      "지방 미분양이 7만 호를 돌파하며 역대 최고 수준에 근접했다. 대구·부산·광주 등 지방 광역시의 하락세가 지속되며 수도권과의 양극화가 심화되었다.",
      "서울 주요 재개발·재건축 조합설립 인가가 잇따르며 정비사업에 탄력이 붙었다. 새 정부의 공급 확대 기조와 맞물려 사업 속도가 빨라졌다.",
      "용산구가 상반기 최고 상승률을 기록하며 '용산 시대'라는 평가가 나왔다. 대통령실 이전 효과와 재개발 기대감이 복합적으로 작용했다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 월간 0.35~0.45% 상승하며 상승폭이 확대되었다. 상반기 누적 약 3~4% 상승을 기록했다. 용산구가 상반기 최고 상승률을 보였고, 강남·서초·송파가 뒤를 이었다. 거래량은 월 5,500건 수준으로 안정적인 흐름을 유지했다. 전세가격도 꾸준히 상승하며 매매가와 동조화 현상이 나타났다. 7월 서울 아파트 평균 매매가가 14억원을 돌파할 것이라는 전망이 나왔다.",
    interestRate:
      "6월 금통위는 개최되지 않았다(연 8회 운영). 상반기 두 차례 인하(2월, 5월) 효과를 관찰하는 기간이었다. 미국 연준은 6월 FOMC에서 기준금리를 4.25~4.50%로 동결했다. 인플레이션 둔화가 확인되었으나 관세 정책 불확실성이 인하를 미루게 했다. 시중 주담대 금리는 변동금리 기준 3.4~4.1% 수준이었다.",
    reconstruction:
      "이재명 정부는 향후 5년간 수도권 135만 호 공급 목표를 제시하며 공급 확대 의지를 밝혔다. 은마아파트는 연내 사업시행인가를 목표로 추진 중이었다. 잠실·송파권에서는 올림픽선수기자촌의 신통기획 자문이 진행되었고, 방이동 일대 정비구역 지정도 추진되었다. 재건축 초과이익환수제 완화 논의도 새 정부 출범 이후 본격화되었다.",
    outlook:
      "하반기에는 새 정부의 추가 부동산 대책 발표가 예상되며, 규제 강도에 따라 시장 흐름이 크게 달라질 수 있다는 분석이 나왔다. 미 연준의 하반기 금리 인하 기대감이 한국 부동산 시장에도 긍정적 요인으로 작용할 전망이었다.",
  },
  {
    year: 2025,
    month: 7,
    headline: "서울 아파트 평균 매매가 14억 원 첫 돌파, 비수기에도 상승세 지속",
    summary:
      "여름 비수기에도 불구하고 서울 아파트 매매가격 상승세가 이어지며 평균 매매가가 사상 처음으로 14억 원을 돌파했다.",
    policy: [
      "한국은행은 7월 금통위에서 기준금리를 2.50%로 동결했다. 부동산 시장 과열 조짐과 가계부채 증가에 대한 경계감이 추가 인하를 제약했다.",
      "정부는 생애최초 주택구입 취득세 감면 한도를 200만원에서 300만원으로 상향하는 시행령을 개정했다. 실수요자 지원 강화 차원이었다.",
      "서울시는 모아타운 사업 50개 구역을 추가 지정하며, 소규모 정비사업을 통한 주택공급 확대에 나섰다.",
      "국토교통부는 재건축 초과이익환수제 완화 시행령을 개정하여, 초과이익 면제 기준을 상향했다. 재건축 사업의 경제성 개선을 위한 조치였다.",
      "이재명 정부는 향후 5년간 수도권 135만 호 공급 목표를 재확인하며, 3기 신도시와 도심 정비사업의 속도를 높이겠다고 밝혔다.",
    ],
    issues: [
      "KB부동산 기준 서울 아파트 평균 매매가가 7월 14억 572만원을 기록하며 사상 처음으로 14억원을 돌파했다. '15억 시대'에 대한 전망이 등장하기 시작했다.",
      "여름 비수기에도 불구하고 서울 매매 거래량이 월 5,000건 이상을 유지했다. 금리 인하 효과와 공급 부족 우려가 매수세를 유지시킨 것으로 분석되었다.",
      "수도권 신축과 구축의 가격 격차가 평균 30% 이상으로 벌어지며, '신축 프리미엄' 현상이 심화되었다.",
      "올림픽파크포레온(구 둔촌주공, 12,032가구)이 2024년 11월 입주 시작 이후 안정 단계에 접어들면서 강동구 주거 환경에 긍정적 변화가 나타났다.",
    ],
    seoulMarket:
      "서울 아파트 평균 매매가가 14억 572만원으로 14억원을 사상 처음 돌파했다(KB부동산 기준). 한국부동산원 주간 상승률은 0.12~0.15% 수준으로 비수기에도 상승세가 이어졌다. 강남·서초·송파의 상승폭이 여전히 컸고, 마포·용산·성동 등 한강벨트의 상승세도 견조했다. 반면 노원·도봉 등 외곽은 보합~소폭 상승에 그쳤다. 거래량은 월 5,100건으로 비수기치고는 양호한 수준이었다.",
    interestRate:
      "한국은행은 7월 금통위에서 기준금리를 2.50%로 동결했다. 이로써 5월 인하 이후 첫 동결을 결정하며, 부동산 시장 과열과 가계부채 증가에 대한 경계감을 내비쳤다. 미국 연준은 7월 FOMC에서 기준금리를 4.25~4.50%로 동결했다. 시장에서는 9월 첫 인하 기대감이 높아졌다. 시중 주담대 금리는 변동금리 기준 3.3~4.0% 수준이었다.",
    reconstruction:
      "올림픽파크포레온(구 둔촌주공, 12,032가구)은 2024년 11월 입주 시작 이후 안정 단계에 접어들었다. 매매가는 분양가 대비 상승한 수준에서 거래되며 재건축 성공 사례로 평가받았다. 은마아파트는 조합설립인가를 향해 마지막 절차를 진행 중이었다. 잠실동 아시아선수촌(1,356가구)은 정비계획 입안 제안을 위한 동의서를 본격적으로 받기 시작했다.",
    outlook:
      "서울 아파트 평균 매매가 14억 돌파는 시장에 상징적 의미가 컸다. 하반기에도 상승세가 이어질 경우 정부의 추가 규제가 불가피하다는 전망이 나왔다. 9월 가을 이사철에 거래량이 더 늘어날 경우 가격 상승 압력이 가중될 수 있다는 분석이었다.",
  },
  {
    year: 2025,
    month: 8,
    headline: "가을 성수기 앞두고 매물 품귀, 정부 추가 공급 대책 발표",
    summary:
      "가을 이사철을 앞두고 서울 아파트 매물이 급감하며 매도자 우위 시장이 형성되었고, 정부는 수도권 택지 추가 지정 등 공급 확대 대책을 발표했다.",
    policy: [
      "한국은행은 8월 금통위에서 기준금리를 2.50%로 동결했다(2회 연속). 경기 둔화보다 가계부채 증가 우려와 부동산 시장 과열에 무게를 둔 결정이었다.",
      "정부는 8·28 주택공급 촉진 대책을 발표하며, 수도권 택지 5곳 추가 지정과 민간 재개발 인허가 패스트트랙 도입을 밝혔다.",
      "서울시는 공공재건축 용적률 인센티브를 강화하여 최대 500%까지 부여하는 방안을 추진했다. 공공분양 물량 확보를 조건으로 민간 사업성을 개선하려는 취지였다.",
      "국토교통부는 민간 재개발 인허가 패스트트랙 제도를 시행하여, 심의·인가 절차를 단축했다.",
    ],
    issues: [
      "서울 아파트 매물(네이버 부동산 기준)이 7만 건 이하로 감소하며 2022년 이후 최저 수준을 기록했다. 매물 품귀에 따른 호가 상승 현상이 두드러졌다.",
      "가을 이사 시즌을 앞두고 매도자 우위 시장이 형성되었다. 급매물은 빠르게 소화되고, 호가를 올려도 매수 문의가 꾸준히 이어지는 분위기였다.",
      "건설사 PF(프로젝트파이낸싱) 부실 우려가 지속되면서 중소 건설사의 경영난이 심화되었다. 일부 현장에서는 공사 지연 사례도 발생했다.",
      "강남·서초 20억원 이상 고가 아파트의 거래 비중이 확대되며 시장의 고가화 추세가 가속화되었다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 주간 0.15~0.20% 상승하며 상승폭이 재차 확대되었다. 매물 품귀에 따른 호가 상승이 주된 원인이었다. 강남·서초 20억원 이상 고가 아파트의 거래 비중이 확대되었고, 마포·성동·광진 등 한강벨트도 견조한 상승세를 이어갔다. 거래량은 월 5,500건 수준으로 가을 성수기 진입을 앞두고 증가세를 보였다.",
    interestRate:
      "한국은행은 8월 금통위에서 기준금리를 2.50%로 2회 연속 동결했다. 경기 부양보다 가계부채 관리와 부동산 시장 안정에 무게를 두는 기조가 확인되었다. 미국에서는 잭슨홀 미팅에서 파월 의장이 추가 금리 인하 여지를 시사하며 글로벌 증시가 반등했다. 중국은 경기부양 대규모 패키지(1조 위안 규모)를 발표했다. 원/달러 환율은 1,320원대로 하락하며 안정세를 보였다.",
    reconstruction:
      "은마아파트가 연내 사업시행인가를 목표로 추진 중이라고 밝혔다. 최고 49층, 5,893가구 규모의 재건축이 2030년 착공, 2034년 준공을 목표로 하고 있었다. 6월 시행된 '재건축 패스트트랙'(30년 이상 안전진단 면제) 효과가 가시화되면서, 그동안 안전진단에 막혀있던 단지들의 사업 추진이 가능해졌다. 재건축 기간이 최대 3년 이상 단축될 것으로 기대되었다.",
    outlook:
      "9월 가을 이사철 본격화로 거래량 급증이 예상되었다. 매물 부족 속 수요 집중으로 가격 상승 압력이 가중될 수 있다는 전망이 나왔다. 미 연준의 9월 금리 인하 가능성도 한국 부동산 시장에 호재로 작용할 것으로 예상되었다. 정부의 추가 규제 대책 가능성도 시장의 주요 변수였다.",
  },
  {
    year: 2025,
    month: 9,
    headline: "가을 성수기 폭발, 서울 거래량 급증 — 연준 9월 금리 인하",
    summary:
      "가을 성수기가 본격화되면서 서울 아파트 거래량이 연중 최고치를 경신했고, 미국 연준의 9월 금리 인하로 글로벌 통화 완화 기조가 강화되었다.",
    policy: [
      "정부는 9·7 주택공급 확대방안의 후속조치를 이행하며, 향후 5년간 수도권 135만 호 공급 목표 달성을 위한 구체적 실행계획을 발표했다.",
      "한국은행은 별도 금통위를 개최하지 않은 달이었다(격월 개최). 시장에서는 10월 금통위에서의 추가 인하 기대감이 있었으나, 부동산 과열 우려로 동결 전망이 우세했다.",
      "국토교통부는 주택청약 제도 전면 개편을 발표하며, 소득 기준 완화와 추첨제 비율 확대를 시행했다. 실수요자의 청약 기회를 넓히려는 취지였다.",
      "서울시는 신속통합기획 심의 속도를 가속화하여 월 10건 이상 처리하겠다고 밝혔다. 정비사업 인허가 병목을 해소하기 위한 조치였다.",
      "6월 시행된 재건축 패스트트랙의 효과가 본격화되었다. 30년 이상 아파트가 안전진단 없이 재건축 절차를 시작하면서, 서울 주요 노후 단지들의 사업 추진이 가속화되었다.",
    ],
    issues: [
      "서울 아파트 거래량이 연중 최고치를 기록했다. 가을 성수기 효과와 금리 인하 기대감이 맞물리며 매수세가 폭발했다. 송파·강남·마포 등 주요 지역에서 신고가 거래가 잇따랐다.",
      "미국 연준이 9월 FOMC에서 기준금리를 0.25%p 인하하여 4.00~4.25%로 조정했다. 2025년 첫 인하로, 1월부터 7월까지 5회 연속 동결 이후 방향 전환이었다. 이는 한국 부동산 시장에도 긍정적 외부 요인으로 작용했다.",
      "서울 평균 전세보증금이 역대 최고치를 경신하며 전세난이 심화되었다. 전세가 상승이 매매가를 밀어올리는 악순환 구조가 강화되었다.",
      "송파구 아파트 가격 상승률이 서울 25개 구 중 최고를 기록하며 '송파 불패'라는 평가가 나왔다. 재건축 기대감과 잠실 일대의 개발 호재가 복합적으로 작용했다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 주간 0.18~0.22% 상승하며 월간으로는 약 0.80% 상승한 것으로 추정된다. 가을 성수기 효과로 모든 자치구에서 상승을 기록했다. 송파구가 월간 최고 상승률을 보였고, 성동·마포·강남이 뒤를 이었다. 거래량은 연중 최고 수준을 기록했다. 전세가격도 주간 0.10~0.14% 상승하며 동반 상승세가 이어졌다.",
    interestRate:
      "미국 연준은 9월 FOMC에서 기준금리를 0.25%p 인하하여 4.00~4.25%로 조정했다. 2025년 첫 인하로, 하반기 금리 인하 사이클의 시작이었다. 한국은행은 9월 금통위 없이 10월 결정을 대기했다. 시중 주담대 금리는 변동금리 기준 3.2~3.8% 수준으로 하락했다. 원/달러 환율은 1,300원대 초반으로 하락하며 안정세를 보였다.",
    reconstruction:
      "6월 시행된 '재건축 패스트트랙' 적용이 확대되면서 서울 노후 아파트 단지들의 사업 추진이 가속화되었다. 은마·잠실주공5·올림픽선수기자촌이 '3대장 재건축'으로 주목받으며 속도전에 나섰다. 은마는 연내 사업시행인가를, 잠실주공5는 조합설립인가를 목표로 추진 중이었다. 서울시는 강남·목동·용산 일대 약 1만 가구 공급을 위한 정비계획안을 가결했다.",
    outlook:
      "서울 아파트 가격 상승세가 정부의 '레드라인'에 근접하고 있다는 분석이 나왔다. 10월 중 대규모 부동산 대책 발표 가능성이 높아졌다. 규제 강화의 방향과 강도가 시장의 최대 관심사였다. 연말까지 상승세가 이어질 경우 연간 상승률이 5%를 넘어설 수 있다는 전망도 등장했다.",
  },
  {
    year: 2025,
    month: 10,
    headline: "10·15 대책 발표 — 서울 전역 투기과열지구 지정, 대출규제 대폭 강화",
    summary:
      "이재명 정부가 10·15 주택시장 안정화 대책을 발표하며 서울 전역을 투기과열지구로 지정하고 LTV를 40%로 하향하는 등 강력한 수요 억제에 나섰다.",
    policy: [
      "정부는 10월 15일 '주택시장 안정화 대책(10·15 대책)'을 발표했다. 이재명 정부의 세 번째 부동산 대책으로, 서울 전역과 경기 12개 지역을 투기과열지구·조정대상지역·토지거래허가구역으로 3중 규제했다.",
      "수도권·규제지역의 LTV(주택담보대출비율)가 70%에서 40%로 대폭 하향되었다. 시가 15억원 이하 주택의 주담대 한도는 6억원, 15~25억원은 4억원, 25억원 초과는 2억원으로 차등 적용되었다.",
      "스트레스 DSR 가산금리가 1.5%에서 3.0%로 상향 조정되었다. 1주택자의 수도권·규제지역 전세대출 이자상환분도 DSR에 반영하도록 했다.",
      "한국은행은 10월 23일 금통위에서 기준금리를 2.50%로 동결했다(3회 연속). 부동산 과열과 가계부채 증가에 대한 우려가 동결의 주된 배경이었다.",
      "국세청은 30억원 이상 초고가 주택 거래와 고가 아파트 증여거래를 전수 검증하겠다고 밝혔다. 시세조작 중개업소에 대한 집중 점검도 예고되었다.",
    ],
    issues: [
      "10·15 대책 발표 직후 매수심리가 급격히 위축되었다. 서울 아파트 거래량이 전월 대비 20% 이상 감소하며 관망세가 확산되었다. '패닉 셀링'까지는 아니지만 호가가 일부 조정되는 단지도 나타났다.",
      "규제 강화에도 불구하고 강남·서초·송파 등 핵심지의 가격은 큰 하락 없이 보합~소폭 상승을 유지했다. '똘똘한 한 채' 선호 현상이 오히려 강화되는 양상이었다.",
      "3기 신도시 남양주왕숙 본청약이 실시되어 평균 경쟁률 15:1을 기록했다. 높은 경쟁률은 주택 수요가 여전히 견고함을 보여주었다.",
      "대출 규제 강화로 실수요자까지 피해를 보게 되었다는 비판이 제기되었다. 특히 신혼부부와 생애최초 주택구입자의 대출 한도가 크게 줄어들어 형평성 논란이 일었다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 10·15 대책 발표 이후 상승폭이 크게 축소되었다. 한국부동산원 주간 상승률이 0.15% 이상에서 0.08~0.10% 수준으로 둔화되었다. 다만 하락 전환까지는 이르지 않았다. 거래량은 전월 대비 20% 이상 급감했다. 강남·서초는 보합~소폭 상승을 유지한 반면, 외곽 지역에서는 일부 약보합 전환이 나타났다. 전세시장은 상대적으로 영향이 적어 상승세가 이어졌다.",
    interestRate:
      "한국은행은 10월 23일 금통위에서 기준금리를 2.50%로 3회 연속 동결했다. 부동산 시장 과열과 가계부채 증가 우려가 인하를 제약했다. 10·15 대책의 대출 규제 강화(LTV 40%, 스트레스 DSR 3.0%)가 시중 대출시장에 미치는 영향이 주목되었다. 미국 연준은 10월 FOMC에서 기준금리를 0.25%p 인하하여 3.75~4.00%로 조정했다. 원/달러 환율은 1,340~1,370원대에서 등락했다.",
    reconstruction:
      "10·15 대책에도 불구하고 재건축·재개발 관련 규제 완화 기조는 유지되었다. 정부는 공급 확대를 위해 재건축 규제를 풀되, 수요 측면에서는 대출과 세제로 억제하는 이중 전략을 구사했다. 6월 시행된 '재건축 패스트트랙'(30년 이상 안전진단 면제)의 적용이 계속 확대되었다. 사업시행인가와 관리처분인가를 '통합 총회'로 한 번에 처리하는 절차 간소화도 추진되었다.",
    outlook:
      "10·15 대책의 시장 영향을 관찰하는 시기였다. 과거 강력한 규제 대책이 단기적으로는 거래량을 줄이지만, 중장기적으로는 매물 잠김 현상으로 가격 하락을 제한한다는 분석이 나왔다. '규제의 역설'이 재현될 수 있다는 우려였다. 연말 비수기 진입과 맞물려 거래량 추가 감소가 예상되었다.",
  },
  {
    year: 2025,
    month: 11,
    headline: "10·15 대책 효과 제한적, 서울 아파트값 상승세 둔화되지만 멈추지 않아",
    summary:
      "10·15 대책 이후 거래량은 크게 줄었지만 서울 아파트 가격은 여전히 상승세를 유지했다. 한국은행은 4회 연속 기준금리를 동결하며 금융안정에 무게를 두었다.",
    policy: [
      "한국은행은 11월 27일 금통위에서 기준금리를 2.50%로 4회 연속 동결했다. 원/달러 환율이 1,470원대까지 터치하는 고공행진을 보인 것이 동결의 주된 배경이었다. 신성환 위원만 0.25%p 인하 소수의견을 제시했다.",
      "금융위원회는 가계대출 관리 기조를 유지하되, 실수요자 예외 적용을 일부 검토한다고 밝혔다. 신혼부부·생애최초 주택구입자에 대한 대출 규제 완화 논의가 시작되었다.",
      "국토교통부는 2026년 주택공급 계획을 발표하며, 전국 47만 호(수도권 25만 호) 공급 목표를 제시했다.",
      "서울시는 재개발·재건축 정비계획 일괄 수립을 추진한다고 발표하며, 인허가 절차 단축에 나섰다.",
    ],
    issues: [
      "10·15 대책 발표 후 한 달이 지났지만 서울 아파트 가격 하락은 나타나지 않았다. 거래량은 크게 줄었으나 매물도 함께 감소하면서 가격은 보합~소폭 상승을 유지했다. 규제 효과가 제한적이라는 평가가 나왔다.",
      "연말 비수기 진입과 대출 규제 강화가 겹치면서 거래량이 월 3,500~4,000건 수준으로 감소했다. 매수·매도 모두 관망세가 강해졌다.",
      "2026년 서울 입주 예정 물량이 약 2.5만 가구로 전년 대비 크게 감소할 것이라는 전망이 나오면서, 공급 부족 우려가 가격 하방을 지지했다.",
      "오피스텔·빌라 등 비아파트 시장은 침체가 지속되었다. 역전세난 우려가 확산되며 다세대·빌라 시장의 구조적 문제가 부각되었다.",
    ],
    seoulMarket:
      "서울 아파트 매매가격은 월간 0.77% 상승했다(한국부동산원 기준). 10·15 대책 영향으로 10월(0.80% 이상)보다 소폭 축소되었으나 여전히 높은 수준이었다. 거래량 감소에도 가격이 하락하지 않는 '거래 없는 가격 상승' 패턴이 나타났다. 강남권은 보합~소폭 상승, 외곽은 일부 지역에서 약보합 전환이 관찰되었다.",
    interestRate:
      "한국은행은 11월 27일 기준금리를 2.50%로 4회 연속 동결했다. 환율 불안(원/달러 1,470원대)과 부동산 시장 과열이 동결의 핵심 배경이었다. 금통위 결정문은 '추가 인하 가능성을 열어두되 금융안정 상황을 면밀히 점검하겠다'고 밝혔다. 미국 연준의 12월 추가 인하 기대감이 높아지며 글로벌 증시는 연말 랠리를 시작했다.",
    reconstruction:
      "재건축 패스트트랙(30년 이상 안전진단 면제)이 6월 시행 이후 적용 사례가 확대되었다. 통합 총회 제도(사업시행인가+관리처분인가 일괄 처리)도 도입이 확정되었다. 은마아파트는 2030년 착공, 2034년 준공을 목표로 사업 일정을 구체화했다. 서울시는 2031년까지 강남구 2.5만 호, 서울 전역 31만 호 공급 목표를 재확인했다.",
    outlook:
      "연말 비수기 진입으로 거래량 추가 감소가 예상되었으나, 가격 하락 전환은 어려울 것이라는 분석이 우세했다. 2026년에는 공급 부족이 심화되면서 가격 상승 압력이 계속될 것이라는 전망이 지배적이었다. 정부의 추가 규제 여부가 주요 변수였다.",
  },
  {
    year: 2025,
    month: 12,
    headline: "2025년 결산 — 서울 아파트 연간 8.98% 상승, 19년 만에 최고 상승률",
    summary:
      "2025년 서울 아파트 매매가격은 한국부동산원 기준 연간 8.98% 상승하며 2006년 이후 19년 만에 최고 상승률을 기록했다. 평균 매매가는 15억원을 돌파했다.",
    policy: [
      "정부는 2026년 경제정책 방향을 발표하며, 주택시장 안정과 공급 확대를 병행하는 기조를 유지하겠다고 밝혔다. 10·15 대책의 규제를 유지하면서도 공급 측면의 속도를 높이겠다는 방침이었다.",
      "미국 연준은 12월 FOMC에서 기준금리를 0.25%p 인하하여 3.50~3.75%로 조정했다. 2025년 세 번째이자 마지막 인하였다. 두 명의 위원이 동결을 주장하며 반대했다.",
      "국토교통부는 2026년 공시가격 현실화율을 동결(69%)하기로 결정했다. 급격한 보유세 인상을 방지하려는 조치였다.",
      "금융위원회는 2026년 가계부채 관리 계획을 발표하며, DSR 규제를 현행 유지하겠다고 밝혔다.",
      "세제 합리화를 위한 연구용역과 관계부처 T/F 논의가 진행되었다. 보유세·거래세 조정과 특정지역 수요 쏠림 완화를 위한 세제 합리화 방안이 검토되었다.",
    ],
    issues: [
      "2025년 서울 아파트 매매가격은 한국부동산원 기준 연간 8.98% 상승하며 통계 공표 이래 역대 최고치를 기록했다. 2006년(23.46%) 이후 19년 만에 가장 높은 상승률이었다.",
      "KB부동산 기준 서울 아파트 평균 매매가가 12월 15억 810만원을 기록하며 사상 처음으로 15억원을 돌파했다. 7월 14억원 돌파 후 5개월 만이었다.",
      "구별 상승률 격차가 극대화되었다. 송파구 20.52% 폭등 vs 도봉구 0.85% 소폭 상승으로, 같은 서울 내에서도 25배 차이가 났다. '똘똘한 한 채' 현상이 극명하게 나타났다.",
      "지방 광역시 평균 매매가는 소폭 하락하며 수도권과의 양극화가 더욱 심화되었다. 대구·광주·부산의 하락세가 두드러졌다.",
      "서울 아파트 시가총액이 1,847조원으로 역대 최대를 기록했다. 재건축 추진 단지들이 시가총액 증가를 주도했다.",
    ],
    seoulMarket:
      "12월 서울 아파트 매매가격은 월간 0.87% 상승했다(한국부동산원 기준). 10·15 대책에도 불구하고 상승세가 꺾이지 않았다. 연간 누적 8.98% 상승으로 마감했다. 평균 매매가 15억 810만원, 중위가 11억 556만원 모두 사상 최고치를 경신했다. 구별로는 송파(20.52%), 성동(18.72%), 마포(14.00%), 서초(13.79%), 강남(13.36%) 순이었다. 반면 중랑(0.76%), 도봉(0.85%), 강북(0.98%)은 1% 미만 상승에 그쳤다.",
    interestRate:
      "한국은행 기준금리는 2.50%로 연말을 마감했다. 2025년 총 2회 인하(2월, 5월)로 연초 3.00%에서 0.50%p 내려갔다. 2024년 10월부터의 누적 인하폭은 1.00%p(3.50%→2.50%). 하반기 4회 연속 동결은 부동산 과열과 환율 불안에 대한 경계 때문이었다. 미국 연준은 12월 인하로 기준금리를 3.50~3.75%로 낮췄다. 2025년 총 3회, 0.75%p 인하. 시중 주담대 금리는 10·15 대책 이후 소폭 상승하여 변동금리 3.5~4.2%, 고정금리 3.8~4.5% 수준이었다.",
    reconstruction:
      "2025년은 서울 재건축·재개발의 전환점이 된 해였다. 재건축 패스트트랙(30년 이상 안전진단 면제), 통합 총회 제도, 조합설립 동의율 완화(70%) 등 제도적 개선이 대거 이루어졌다. 은마아파트(49층, 5,893가구)는 2030년 착공을 목표로 사업시행인가 절차를 진행 중이었다. 서울시는 2031년까지 31만 호 공급 목표를 설정하고, 신통기획 시즌2를 통해 강남·여의도·목동·성수 등 주요 지역의 정비사업 속도를 높였다.",
    outlook:
      "2026년 서울 아파트 가격은 주택산업연구원 기준 4.2% 상승이 전망되었다. 공급 부족(서울 입주 예정 물량 감소)과 금리 인하 기대감이 상승 요인, 10·15 대책 등 규제 강화가 하락 요인으로 작용할 것으로 분석되었다. '똘똘한 한 채' 현상의 심화와 수도권·비수도권 양극화가 2026년에도 이어질 것이라는 전망이 지배적이었다.",
  },
  {
    year: 2026,
    month: 1,
    headline: "새해 부동산 시장 신중한 출발, 한은 5회 연속 동결 — 추가 인하 문구 삭제",
    summary:
      "2026년 새해 부동산 시장은 10·15 대책 규제와 연말 비수기 여파 속에서 신중하게 출발했다. 한국은행은 5회 연속 기준금리를 동결하며 추가 인하 언급을 삭제했다.",
    policy: [
      "한국은행은 2026년 첫 금통위에서 기준금리를 2.50%로 만장일치 5회 연속 동결했다. 주목할 점은 기존의 '추가 금리 인하를 고려한다'는 문구가 삭제된 것으로, 현재의 완화 사이클이 끝났음을 시사했다.",
      "정부는 1·15 부동산 시장 점검회의를 개최하며 수도권 공급 확대와 10·15 대책 규제 유지를 재확인했다. 서울 전역 투기과열지구·토지거래허가구역 지정이 유지되었다.",
      "서울시는 2026년 정비사업 촉진 로드맵을 발표하며, 재건축 30개 단지의 사업 속도전을 선언했다.",
      "국토교통부는 3기 신도시 착공 일정을 구체화하며, 2026년 상반기 일부 지구 착공을 밝혔다.",
      "종부세 기본공제 14억원 적용이 2026년 귀속분부터 시작되었다. 1주택자의 종부세 부담이 다소 경감되었다.",
    ],
    issues: [
      "새해 부동산 시장은 10·15 대책 규제와 연말 비수기 여파가 이어지며 거래량이 전년 동월 대비 소폭 감소했다. 매수·매도 모두 관망세가 지배적이었다.",
      "연초 비수기와 설 연휴(2/14~2/18)를 앞두고 시장 활동이 위축되었다. 다만 강남·용산·마포 등 핵심지의 신축 아파트에 대한 관심은 여전히 높았다.",
      "2026년 서울 입주 예정 물량이 전년 대비 크게 감소할 것이라는 전망이 나오면서, 전세 시장에서는 불안감이 커졌다. 다만 일부 대단지 입주(올림픽파크포레온 잔여분 등)로 국지적 안정은 기대되었다.",
      "원/달러 환율이 16년 만에 최저치 근처에서 맴돌며 금융 안정성 우려가 높아졌다. 한은의 기준금리 동결과 추가 인하 문구 삭제의 배경이 되었다.",
    ],
    seoulMarket:
      "1월 서울 아파트 매매가격은 전월 대비 소폭 상승하며 보합에 가까운 흐름을 보였다. 10·15 대책 규제와 연말·연초 비수기 효과가 맞물렸다. 거래량은 전월 대비 소폭 증가했으나 전년 동월 대비로는 감소했다. 강남권은 보합~소폭 상승을 유지했고, 비강남권은 지역에 따라 보합~약보합으로 갈렸다. 전세 시장은 입주물량 감소 전망에 따른 불안감으로 상승 압력이 이어졌다.",
    interestRate:
      "한국은행은 2026년 1월 금통위에서 기준금리를 2.50%로 만장일치 동결했다. 2024년 10월 이후 누적 100bp 인하 이후 현재의 완화 사이클 종료를 시사했다. 특히 '추가 인하 고려' 문구를 삭제하며 신중한 태도를 보였다. 원화 약세(16년 만의 최저치), 가계부채, 부동산 가격이 동결의 주된 배경이었다. 미국 연준도 1월 FOMC에서 기준금리를 3.50~3.75%로 동결하며 예상에 부합했다. 트럼프 행정부 2년차 관세 정책 불확실성이 이어졌다.",
    reconstruction:
      "서울시가 2026년 정비사업 촉진 로드맵을 발표하며 30개 재건축 단지의 속도전을 선언했다. 재건축 패스트트랙(30년 이상 안전진단 면제)이 본격 시행되면서, 그동안 안전진단에 막혀있던 단지들의 사업 추진이 가능해졌다. 은마아파트는 사업시행인가 절차를 진행 중이었고, 잠실·목동·여의도 등 주요 정비구역의 사업 속도가 빨라질 것으로 기대되었다.",
    outlook:
      "2026년 서울 부동산 시장은 공급 부족과 규제 강화의 줄다리기가 핵심 테마가 될 전망이었다. 주택산업연구원은 서울 4.2%, 수도권 2.5% 상승을 전망했다. 금리 인하 사이클 종료 시사에 따라 추가 유동성 유입은 제한적일 수 있으나, 구조적 공급 부족이 가격을 지지할 것으로 분석되었다. 상반기 중 정부의 추가 대책 발표 여부와 3기 신도시 착공 진행 상황이 주요 관전 포인트였다.",
  },
  {
    year: 2026,
    month: 2,
    headline:
      "이재명 대통령, 등록임대 양도세 특혜 축소 시사 — 매물 급증 속 매수심리 위축",
    summary:
      "이재명 대통령이 등록임대주택의 양도세 중과 제외 특혜 축소를 시사하면서 다주택자 매물 출회 기대감이 확산되었다. 서울 아파트 매물은 6만 건을 돌파했으나 매수심리는 급격히 위축되며 관망세가 짙어졌다.",
    policy: [
      "이재명 대통령은 2월 10일 SNS를 통해 등록임대주택 사업자에 대한 양도세 중과 제외 혜택 축소를 시사했다. '같은 다주택인데 한때 등록 임대였다는 이유로 영구적으로 특혜를 줄 필요가 있느냐'며, 임대 기간 종료 후 세제를 일반 임대주택과 동일하게 맞추는 것이 공평하다고 밝혔다. 서울 시내 등록 임대주택 약 30만 호의 매각을 유도하여 시장에 4만 2,500가구 규모의 공급 효과를 기대했다.",
      "다주택자 양도세 중과 유예가 5월 9일 종료를 앞두고, 대통령은 '유예 기간 이전에 매각한 다주택자보다 버틴 다주택자가 유리하도록 방치할 수 없다'며 금융·세제·규제를 종합 동원해 '매각이 이익, 보유가 부담'인 구조를 만들겠다는 방침을 발표했다.",
      "2월 10일부터 외국인 주택 거래 관리가 강화되었다. 2년 실거주 요건에 더해 체류자격·국내 주소 보유 여부·183일 이상 거소 여부도 자금조달계획서와 함께 신고해야 했다.",
      "소규모주택정비사업 촉진을 위한 가로구역 기준이 완화되어, 도심 내 소규모 정비사업의 문턱이 낮아졌다.",
      "국토교통부는 조상땅찾기 서비스를 2월 12일 대폭 개편하여 서류 제출 없이 정보 제공 동의만으로 온라인 신청이 가능하도록 절차를 간소화했다.",
    ],
    issues: [
      "서울 아파트 매물이 2월 들어 6만 건을 돌파하며 매물 급증세를 보였다. 1월 초 5.7만 건에서 약 4.1% 증가한 것으로, 다주택자 양도세 중과 유예 종료(5월)를 앞두고 매도 물량이 늘어난 영향이었다. 2월 말에는 7만 2,049건까지 치솟았다.",
      "이재명 대통령의 등록임대 특혜 축소 발언 이후 매수자들은 일제히 관망세로 돌아섰다. 매매가격 전망지수는 110.8로 전달(124.7) 대비 13.9포인트 급락하며 시장 심리가 크게 위축되었다.",
      "전세 시장 축소가 가속화되었다. 서울 전세 매물은 전년 동월 대비 36.7% 감소한 1만 8,520건에 그쳤고, 전세를 구하지 못한 세입자들이 월세로 이동하면서 서울 오피스텔 월세 가격이 13개월 연속 상승했다.",
      "서울 아파트 매매 거래의 87.2%가 15억원 이하에 집중되었다. 정부의 가격대별 주담대 한도 차등 적용(15억원 이하 6억원, 15~25억원 4억원, 25억원 초과 2억원) 정책이 거래 패턴을 변화시킨 것으로 분석되었다.",
    ],
    seoulMarket:
      "2월 서울 아파트 매매가격은 전월 대비 1.34% 상승하며 21개월 연속 오름세를 이어갔다. 주간 변동률은 0.22% 수준으로 53주 연속 상승을 기록했다. 그러나 매물이 6만 건을 돌파하고 매수심리가 급격히 위축되면서 상승 폭은 둔화 조짐을 보였다. 강남 3구는 거래량이 전월 대비 20% 넘게 감소하며 관망세가 두드러졌다. 전세 시장은 매물 부족이 심화되어 전월세 물건이 전월 대비 16% 감소한 3만 5,676건에 그쳤고, 전세에서 월세로의 전환이 가속화되었다.",
    interestRate:
      "한국은행은 2월 26일 금통위에서 기준금리를 2.50%로 6회 연속 만장일치 동결했다. 올해 실질 GDP 성장률 전망치를 1.8%에서 2.0%로 상향 조정했으며, 반도체 수출 호조와 소비 회복세를 반영했다. 소비자물가 상승률 전망도 2.1%에서 2.2%로 올렸는데, 미국-이란 군사적 긴장 고조에 따른 유가 상승이 고려되었다. 미국 연준도 1월 FOMC에서 기준금리를 3.50~3.75%로 동결했으며, 3월 동결 확률이 96%로 반영되었다. 시중 주담대 금리는 변동금리 3.8~4.2%, 고정금리 4.0~4.5% 수준이었다.",
    reconstruction:
      "재건축 규제 완화의 핵심인 '재건축진단' 제도 개편이 진행되었다. 기존 안전진단을 재건축진단으로 정비하고, 진단 시점을 사업시행계획인가 전까지 유예할 수 있도록 해 초기 단계의 부담을 낮추는 방향이었다. 반포디에이치클래스트(5,002세대)의 2026년 상반기 분양이 가시화되면서 서울 단일 재건축 단지 역대 최대 규모 분양에 시장의 관심이 집중되었다. 소규모주택정비사업 가로구역 기준 완화로 도심 내 소규모 정비사업의 추진이 한층 수월해졌다.",
    outlook:
      "다주택자 양도세 중과 유예 종료(5월 9일)가 다가오면서 매물 출회가 가속화될 것으로 전망되었다. 정부의 '매각이 이익, 보유가 부담' 기조가 강화됨에 따라 매수·매도 간 가격 줄다리기가 치열해질 것으로 보였다. 전세 시장은 매물 부족과 월세 전환 가속화로 불안정한 흐름이 이어질 전망이었다. 3월 봄 이사철과 맞물려 거래량 변화 추이가 주목되었고, 반포디에이치클래스트 분양 등 대형 이벤트가 시장 분위기에 영향을 줄 것으로 예상되었다.",
  },
  {
    year: 2026,
    month: 3,
    headline:
      "봄 이사철에도 상승폭 축소·강남 하락 — 양도세 유예 종료(5·9) 앞두고 관망",
    summary:
      "10·15 대책 여파와 연초 비수기가 이어지며 서울 아파트 상승폭이 축소되고 강남구는 하락세를 보였다. 다주택자 양도세 중과 유예 종료(5월 9일)를 앞두고 절세 매물이 늘며 매수·매도 모두 관망세가 짙어졌다.",
    policy: [
      "3월에는 금통위가 열리지 않았다(연 8회 운영). 2월 6회 연속 동결(2.50%)과 '추가 인하 고려' 문구 삭제 이후, 시장은 4월 금통위를 주시했다.",
      "정부는 앞서 2월 2일 '다주택자 양도세 중과 유예 연장은 없다'고 못박았고, 5월 9일 종료를 앞두고 절세 목적 매도 물량에 대한 모니터링을 강화했다.",
      "미국 연준은 3월 FOMC에서 기준금리를 3.50~3.75%로 동결했다. 점도표상 2026년 1회·2027년 1회 인하 전망이 유지되었다.",
      "국토교통부는 3기 신도시(남양주왕숙·하남교산 등) 상반기 착공과 2026년 수도권 25만 호 공급 목표 이행을 재확인했다.",
      "서울시는 재건축진단 제도 개편(안전진단→재건축진단, 진단 시점을 사업시행계획인가 전까지 유예)을 이어가며 정비사업 초기 부담을 낮췄다.",
    ],
    issues: [
      "10·15 대책의 대출 규제(LTV 40%, 스트레스 DSR 3.0%)와 연초 비수기가 겹치며 서울 아파트 상승폭이 축소되었다. 강남구는 3월 하락하며 조정 국면에 들어섰다.",
      "양도세 중과 유예 종료(5/9)를 앞두고 다주택자 절세 매물이 늘었다. 매물은 쌓였지만 매수세는 신중해 거래는 부진했다.",
      "대출 부담이 상대적으로 낮은 중저가 아파트에 실수요가 집중되는 흐름이 나타났다. 가격대별 대출 한도 차등(15억 이하 6억 등)이 거래 패턴을 좌우했다.",
      "전세는 매물 부족 속 상승세가 이어졌고, 전세를 구하지 못한 수요의 월세 전환이 계속되었다.",
    ],
    seoulMarket:
      "3월 서울 아파트 매매가격은 상승폭이 축소되며 조정 양상을 보였다. 특히 강남구가 하락하는 등 고가 지역이 약세를 보인 반면, 중저가 실수요가 몰린 일부 중급지·외곽은 상대적으로 버텼다. 10·15 대책 규제와 양도세 종료를 앞둔 매물 증가가 매수심리를 눌렀다. 거래량은 봄 이사철임에도 회복이 더뎠다. 전세는 매물 부족으로 상승세가 지속되었다.",
    interestRate:
      "3월에는 한국은행 금통위가 열리지 않았다(연 8회 운영). 기준금리는 2.50%로 유지되었다. 미국 연준은 3월 FOMC에서 기준금리를 3.50~3.75%로 동결하고, 점도표상 2026년 1회·2027년 1회 인하 전망을 제시했다. 원화 약세가 이어지며 원/달러 환율은 1,400원대 중후반에서 등락했다. 시중 주담대 금리는 변동금리 3.7~4.3%, 고정금리 3.9~4.5% 수준이었다.",
    reconstruction:
      "재건축진단 제도 개편으로 노후 단지의 초기 사업 진입 문턱이 낮아지면서 정비계획 수립·조합설립을 먼저 진행하는 단지가 늘었다. 은마아파트와 잠실주공5단지 등 강남권 대표 재건축 단지들이 20여 년 만에 사업에 속도를 내기 시작했다. 반포디에이치클래스트(전용 59~130㎡, 일반분양 약 1,832가구)의 하반기 분양이 예고되며 강남권 신축 시세에 대한 관심이 이어졌다.",
    outlook:
      "4월 금통위의 금리·기조와 5월 9일 양도세 중과 유예 종료가 상반기 최대 변수로 지목되었다. 종료를 앞두고 4~5월 절세 매물 출회가 정점에 이를 것으로 전망되었다. 규제·비수기로 눌린 매수심리가 봄 이사철 후반과 금리 흐름에 따라 어떻게 움직일지가 관건이었다.",
  },
  {
    year: 2026,
    month: 4,
    headline:
      "한은 7회 연속 동결(2.50%) — 서울 실거래가 상승 전환, 중저가·강남 온도차",
    summary:
      "한국은행이 이란 전쟁발 유가 상승 등 불확실성 속에 기준금리를 2.50%로 7회 연속 동결했다. 서울 아파트 실거래가는 전월 대비 상승 전환했으나, 대출 규제로 중저가 실수요가 몰린 권역이 상승을 주도하고 강남권은 하락세가 이어지며 온도차가 뚜렷했다.",
    policy: [
      "한국은행은 4월 금통위에서 기준금리를 2.50%로 7회 연속 동결했다. 이란 전쟁에 따른 유가 상승과 공급망 차질로 물가·성장 불확실성이 커진 점이 배경이었다.",
      "다주택자 양도세 중과 유예 종료(5월 9일)가 임박하면서 정부는 유예 연장 불가 방침을 최종 확인했다. 국세청은 종료 직전 절세 매각과 편법 증여를 집중 점검했다.",
      "미국 연준은 4월 FOMC(28~29일)에서 기준금리를 3.50~3.75%로 동결했다. 시장은 동결 확률을 99% 이상으로 반영했다.",
      "국토교통부는 3기 신도시 일부 지구 상반기 착공에 들어가며 수도권 공급 확대 의지를 재확인했다.",
      "금융위원회는 10·15 대책의 큰 틀을 유지하되 신혼부부·생애최초 등 실수요자 대출 규제를 일부 미세 조정했다.",
    ],
    issues: [
      "한국부동산원 집계 4월 서울 아파트 매매 실거래가가 전월 대비 0.08% 올라 상승 전환했다. 전년 동월 대비로는 12.86% 높은 수준이었다.",
      "권역별 차별화가 뚜렷했다. 동북·서남·서북권 실거래가는 오른 반면 도심권과 동남권(강남권)은 하락했다. 강남구는 4월에도 하락세가 이어졌다.",
      "대출 규제로 자금 부담이 낮은 중저가 아파트에 실수요가 집중되었다. 1~4월 누적 실거래가격지수는 서울 전역 3.2% 상승(동북 4.6%, 서남 4.4%, 서북 3.0%)을 기록했다.",
      "양도세 유예 종료를 한 달 앞두고 절세 매물이 늘며 매물 부담이 커졌다. 매수자들은 종료 이후 추가 매물·가격 조정을 지켜보며 관망했다.",
    ],
    seoulMarket:
      "4월 서울 아파트 매매 실거래가는 전월 대비 0.08% 상승하며 상승 전환했다(전년 동월 대비 +12.86%). 다만 상승은 대출 규제로 자금 부담이 낮은 중저가 아파트에 실수요가 몰린 동북·서남·서북권이 주도했고, 도심·동남권(강남권)은 하락했다. 강남구는 4월에도 하락세가 이어지며 고가권 조정이 지속되었다. 봄 이사철 성수기에도 절세 매물 증가와 관망세로 거래 회복은 제한적이었다. 전세는 매물 부족으로 상승세가 이어졌다.",
    interestRate:
      "한국은행은 4월 금통위에서 기준금리를 2.50%로 7회 연속 동결했다. 이란 전쟁발 유가 상승과 공급망 차질에 따른 물가·성장 불확실성이 신중한 기조의 배경이었다. 미국 연준은 4월 FOMC(28~29일)에서 3.50~3.75%로 동결했고, 시장은 동결 확률을 99% 이상으로 반영했다. 원화 약세가 이어지며 원/달러 환율은 1,400원대 중후반에서 등락했다. 시중 주담대 금리는 변동금리 3.7~4.2%, 고정금리 3.9~4.4% 수준이었다.",
    reconstruction:
      "강남권 재건축이 봄 들어 본격화되었다. 은마아파트와 잠실주공5단지가 20여 년 만에 사업에 속도를 내며 조합·인가 절차를 진행했다. 재건축진단 제도 개편 효과로 초기 단계 단지들의 정비계획 수립이 활발했다. 반포디에이치클래스트(일반분양 약 1,832가구)의 하반기 분양이 예정되며, 인근 래미안 트리니원이 세 자릿수 청약 경쟁률을 기록한 전례가 회자되는 등 강남권 신축 청약 기대가 이어졌다.",
    outlook:
      "5월 9일 양도세 중과 유예 종료가 상반기 최대 분수령으로 지목되었다. 종료 직전 매물이 정점을 찍은 뒤 소화 속도와 가격 향방이 관건이 될 것으로 전망되었다. 중저가 실수요 쏠림과 강남권 조정이 병존하는 가운데, 5월 금통위 금리 결정도 주요 변수였다.",
  },
  {
    year: 2026,
    month: 5,
    headline:
      "양도세 중과 유예 종료(5·9)·한은 8회 연속 동결 — 서울 집값 4개월 만에 최대 상승, 평균 10억 돌파",
    summary:
      "5월 9일 다주택자 양도세 중과 유예가 종료되었다. 종료 직전 급매가 소화된 뒤 매물이 줄며 서울 집값은 4개월 만에 최대폭(월간 0.90%) 올랐고, 3~4월 하락했던 강남구도 상승 전환했다. 서울 평균 주택 매매가격은 사상 처음 10억 원을 넘었다.",
    policy: [
      "5월 9일 다주택자 양도세 중과 유예가 예정대로 종료되었다. 조정대상지역 주택 매도 시 2주택자는 기본세율에 20%p, 3주택 이상은 30%p가 중과되고 장기보유특별공제도 배제된다.",
      "정부는 시장 충격 완화를 위한 보완방안을 내놨다. 강남·서초·송파·용산 소재 주택은 4개월, 2025년 10월 16일 이후 신규 지정 조정대상지역 주택은 6개월의 중과 유예를 추가로 부여하고, 잔금일 기준 최장 6개월까지 유예를 인정했다. 임대 중인 주택의 실거주 의무도 제한적으로 완화했다.",
      "한국은행은 5월 금통위에서 기준금리를 2.50%로 8회 연속 동결했다. 지정학적 위험과 원화 약세, 인플레이션 재발 우려 사이에서 균형을 맞춘 신중한 결정이었다.",
      "국토교통부는 3기 신도시 착공을 이어가며 하반기 사전청약·본청약 일정을 예고했다.",
      "정부는 등록임대주택 양도세 특혜 축소 방안을 구체화하며, 임대 기간 종료 후 세제를 일반 임대주택과 동일하게 맞추는 방향으로 시장 출회를 유도했다.",
    ],
    issues: [
      "서울 주택종합 평균 매매가격지수가 전월 대비 0.90% 올라 4개월(1월 이후) 만에 최대 상승폭을 기록했다. 서울 평균 주택 매매가격은 10억101만원으로 통계 집계 이래 처음 10억 원을 넘었다.",
      "3·4월 두 달 연속 하락했던 강남구가 5월 0.52% 오르며 3개월 만에 상승 전환했다. 재건축 단지를 중심으로 막판 급매가 소화된 뒤 호가가 다시 올랐다.",
      "양도세 종료(5/9) 직전 급매물이 상당수 거래된 뒤 매물이 빠르게 줄면서, 호가 재상승과 매도자 우위 분위기가 형성되었다.",
      "전세 매물 부족은 계속되었고, 매매 관망세와 맞물려 월세 전환이 이어지며 전월세 가격의 상방 압력이 지속되었다.",
    ],
    seoulMarket:
      "5월 서울 주택종합 평균 매매가격지수는 전월 대비 0.90% 상승하며 1월 이후 4개월 만에 최대폭 올랐다. 서울 평균 주택 매매가격은 10억101만원으로 사상 처음 10억 원을 돌파했다. 3~4월 하락했던 강남구가 0.52% 오르며 상승 전환했고, 재건축 단지의 막판 급매 소화 후 호가 반등이 두드러졌다. 양도세 종료 직전 급매물이 소화된 뒤 매물이 줄며 매도자 우위로 분위기가 바뀌었다. 전세는 매물 부족으로 상승세가 이어졌다.",
    interestRate:
      "한국은행은 5월 금통위에서 기준금리를 2.50%로 8회 연속 동결했다. 지정학적 위험(이란 전쟁 등), 원화 약세, 인플레이션 재발 우려가 인하를 제약했다. 완화 사이클에 있음에도 여덟 차례 연속 동결이 이어지며 사실상 관망 국면이 길어졌다. 미국 연준은 5월 FOMC를 열지 않았으며(격월 개최) 3.50~3.75% 수준을 유지했다. 원/달러 환율은 원화 약세 흐름 속 1,400원대 중후반에서 등락했다. 시중 주담대 금리는 변동금리 3.7~4.2%, 고정금리 3.9~4.4% 수준이었다.",
    reconstruction:
      "양도세 종료와 무관하게 재건축·재개발 규제 완화 기조가 유지되었다. 은마아파트와 잠실주공5단지가 20여 년 만에 재건축을 본격화하며 사업에 속도를 냈고, 관련 호재로 호가가 단기 급등하는 단지도 나타났다. 재건축진단 제도 개편으로 초기 단지들의 사업 추진이 활발했다. 반포디에이치클래스트(일반분양 약 1,832가구)의 하반기 분양 준비가 이어지며 강남권 신축 시세 기대가 유지되었다.",
    outlook:
      "양도세 유예 종료 이후 급매 소화와 매물 감소가 맞물리며 하반기 가격 향방에 관심이 쏠렸다. 매물이 빠르게 줄면 상승세가 재개될 수 있다는 관측과, 거래량 자체는 과거 상승장 수준에 못 미친다는 신중론이 병존했다. 6월 이후 상반기 결산 국면에서 강남권 반등의 지속 여부와 하반기 금리 흐름이 핵심 변수로 지목되었다.",
  },
  {
    year: 2026,
    month: 6,
    headline:
      "양도세 종료 후 매물 급감·호가 반등 — 서울 4개월 만에 최대 상승, 연준은 '더 높은 금리 더 오래'",
    summary:
      "양도세 중과 유예 종료 직전 급매가 소화된 뒤 매물이 빠르게 줄며 서울 아파트값이 4개월 만에 최대폭 상승했다. 강남권까지 상승에 동참했으나 거래량은 제한적이었다. 미국 연준은 기준금리를 4회 연속 동결하면서도 점도표로 연내 인상 가능성을 시사해 시장에 충격을 줬다.",
    policy: [
      "6월에는 한국은행 금통위가 열리지 않았다(연 8회 운영). 기준금리는 2.50%로 유지되었으며, 시장은 7월 금통위를 주시했다.",
      "미국 연준은 6월 FOMC에서 기준금리를 3.50~3.75%로 4회 연속 동결했다. 그러나 점도표에서 18명 위원 중 9명이 연내 최소 1회 인상을 예상하고, PCE 물가 전망을 3월 2.7%에서 3.6%로 크게 올리며 '더 높은 금리, 더 오래' 시나리오가 부각되었다. 신임 워시 의장의 데뷔 회의였다.",
      "정부는 양도세 유예 종료 이후 다주택자 매물 출회 효과를 점검하며 10·15 대책 규제 유지와 공급 확대 병행 기조를 재확인했다.",
      "국토교통부는 하반기 3기 신도시 본청약 일정과 수도권 공급 로드맵을 점검했다.",
      "서울시는 정비사업 촉진 로드맵의 상반기 성과를 점검하고 재건축진단·통합 총회 등 절차 간소화 효과를 재확인했다.",
    ],
    issues: [
      "6월 넷째 주 서울 아파트 가격이 0.14% 오르는 등 상승세가 이어졌다. 6월 서울 집값은 4개월 만에 최대폭 상승을 기록했다.",
      "양도세 종료(5/9) 직전 급매물이 소화된 뒤 매물이 빠르게 줄며 호가가 다시 올랐다. 다만 거래량은 과거 상승장 수준까지 회복되지 않아 제한적이었다.",
      "상승이 선호 지역과 재건축 단지를 중심으로 나타난 가운데, 강북권에 이어 강남권까지 오름세에 동참하며 지역 간 격차가 재부각되었다.",
      "6월 서울 아파트 전세가격이 전월 대비 1.43% 올라 올해 들어 가장 높은 상승률을 기록했다. 매물 부족과 월세 전환이 전세시장 불안으로 이어졌다.",
    ],
    seoulMarket:
      "6월 서울 아파트값은 4개월 만에 최대폭 상승했다. 6월 넷째 주 주간 상승률이 0.14%를 기록하는 등 양도세 종료 이후 급매 소화·매물 감소가 호가 반등으로 이어졌다. 강북권에 이어 강남권까지 상승에 동참했으나, 거래량은 과거 상승장 수준에 못 미쳐 '매물 적고 호가 오르는' 국면이었다. 전세가격은 전월 대비 1.43% 올라 올해 최고 상승률을 기록하며 매매·전세 동반 강세가 나타났다.",
    interestRate:
      "6월에는 한국은행 금통위가 열리지 않았다(연 8회 운영). 기준금리는 2.50%로 유지되었고, 7월 금통위가 다음 분수령이었다. 미국 연준은 6월 FOMC에서 3.50~3.75%로 4회 연속 동결했으나, 점도표에서 위원 절반이 연내 인상을 예상하고 PCE 전망을 2.7%에서 3.6%로 올리며 '더 높은 금리, 더 오래' 우려를 키웠다. 신임 워시 의장의 데뷔 무대였다. 원/달러 환율은 원화 약세 속 1,400원대 중후반에서 등락했다. 시중 주담대 금리는 변동금리 3.7~4.3%, 고정금리 3.9~4.5% 수준이었다.",
    reconstruction:
      "은마아파트와 잠실주공5단지가 20여 년 만에 재건축을 본격화하며, 관련 기대감에 호가가 하루 만에 수천만~1억 원씩 오르는 단지도 나타났다. 재건축진단 제도 개편·통합 총회 등 절차 간소화 효과로 강남·목동·여의도 주요 정비구역의 사업 속도가 빨라졌다. 반포디에이치클래스트(일반분양 약 1,832가구)는 하반기(8월경) 분양을 앞두고 강남권 신축 청약 최대어로 주목받았다.",
    outlook:
      "하반기 서울 부동산은 매물 소화 속 호가 반등, 연준의 '더 높은 금리, 더 오래' 기조, 공급 부족의 삼각 구도가 향방을 가를 것으로 전망되었다. 양도세 종료 효과가 매물 감소·호가 상승으로 이어진 가운데 거래량 회복 여부가 관건이었다. 7월 한은 금통위 결정과 반포 대단지 분양 등 하반기 이벤트가 시장 분위기를 좌우할 변수로 지목되었다.",
  },
  {
    year: 2026,
    month: 7,
    headline:
      "한국은행 3년 6개월 만에 기준금리 인상(2.75%)·은행권 대출 조이기에도 서울 74주 연속 상승",
    summary:
      "한국은행이 7월 16일 기준금리를 0.25%p 올려 3년 6개월 만에 긴축으로 전환하고 은행들이 주택담보대출 한도를 잇달아 조였음에도, 서울 아파트값은 74주 연속 상승세를 이어갔다. 공급 부족이 하방을 단단히 지지한 가운데, 코스피 급락으로 증시 자금의 주택시장 회귀 우려가 커졌다.",
    policy: [
      "한국은행 금통위는 7월 16일 기준금리를 2.50%에서 2.75%로 0.25%p 인상했다. 2022년 이후 3년 6개월 만의 인상으로, 집값 상승세와 가계부채·환율 부담에 대응한 긴축 전환이었다.",
      "은행권이 자율적으로 주택대출을 조였다. KB국민은행은 주택담보대출 한도를 3억원으로 제한했고, 우리은행은 월별 주택 관련 대출 한도를 30억원에서 10억원으로 축소했다. 하나·신한·NH농협은 주담대 모기지 보험 신규 가입을 한시적으로 제한했다.",
      "이재명 대통령이 부동산 조세 정상화 필요성을 언급하며 보유세 등 세제 개편 논의가 하반기 화두로 부상했다.",
      "정부·서울시는 10·15 대책 규제 유지 기조 아래 정비사업 촉진과 수도권 공급 확대를 병행 점검했다. 다만 서울 연간 주택 필요량(약 5만 세대) 대비 2027년 입주 예정 물량(1만 7,197세대)이 3분의 1 수준에 그쳐 공급 절벽 우려가 지속되었다.",
    ],
    issues: [
      "서울 아파트 매매가격은 7월 첫째 주(6일 기준) 0.30% 올라, 지난해 2월 3일 상승 전환 이후 74주 연속 오름세를 기록했다. 연초부터 7월 초까지 누적 상승률은 5.24%로, 전년 동기(8.71%)보다는 완만했다.",
      "기준금리 인상과 은행 대출 규제에도 상승세가 꺾이지 않았다. 구조적 공급 부족과 매물 감소가 금리·규제의 하방 압력을 상쇄했다.",
      "코스피가 6월 19일 9,386포인트에서 7월 13일 6,807포인트로 약 27.5% 급락하면서, 증시에서 빠져나온 자금이 주택시장으로 회귀할 수 있다는 우려가 제기되었다. 서울 아파트 가격과 코스피의 상관계수는 0.8566으로 높게 분석됐다.",
      "대출 문턱이 높아지며 실수요자의 자금 조달 부담이 커졌다. 5대 은행 5년 고정형 주담대 금리는 7월 13일 기준 연 4.68~7.39%, 변동형은 연 4.02~6.37% 수준이었고, 기준이 되는 신규 취급액 COFIX는 전월 대비 0.15%p 올랐다.",
    ],
    seoulMarket:
      "서울 아파트값은 7월에도 상승세를 유지했다. 7월 첫째 주 주간 상승률은 0.30%로 74주 연속 오름세를 이어갔고, 연초 대비 누적 상승률은 5.24%에 달했다. 한국은행의 금리 인상(2.75%)과 은행권의 잇단 대출 한도 축소에도, 구조적 공급 부족과 매물 감소가 가격을 떠받쳤다. 다만 코스피 급락(6월 19일 9,386→7월 13일 6,807, 약 -27.5%)으로 증시 자금의 주택시장 유입 여부가 새로운 변수로 떠올랐다.",
    interestRate:
      "한국은행은 7월 16일 금통위에서 기준금리를 2.50%에서 2.75%로 0.25%p 인상했다. 2022년 이후 3년 6개월 만의 인상으로, 집값·가계부채·환율 부담을 반영한 긴축 전환이었다. 이에 따라 5대 은행 5년 고정형 주담대 금리는 7월 13일 기준 연 4.68~7.39%(5월 말 대비 하단 +0.42%p·상단 +0.29%p), 변동형은 연 4.02~6.37%로 올랐고, 신규 취급액 COFIX도 전월 대비 0.15%p 상승했다. 은행권은 금리 인상과 별개로 주담대 한도 축소·모기지 보험 제한 등 대출 총량 조이기에 나섰다.",
    reconstruction:
      "강남권 정비사업은 하반기 분양 대어를 앞두고 열기를 이어갔다. 반포디에이치클래스트(일반분양 약 1,832가구)가 8월경 분양을 예고하며 강남권 신축 청약 최대어로 주목받았고, 은마·잠실주공5단지 등 주요 재건축 단지의 사업 속도도 유지되었다. 다만 금리 인상과 대출 규제가 재건축 투자 수요에 일부 제동을 걸 수 있다는 관측도 나왔다.",
    outlook:
      "하반기 시장은 '금리 인상·대출 규제'와 '공급 부족·매물 감소'의 힘겨루기가 될 전망이었다. 74주 연속 상승에도 거래량은 제한적이어서, 8월 반포 대단지 분양과 보유세 등 세제 개편 논의, 코스피 흐름에 따른 자금 이동이 서울 집값의 향방을 가를 변수로 지목되었다.",
  },
];

export default newsData;
